import i18nInstance from 'i18n/i18nInstance'
import { withI18nContext, useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { Locations } from '@mc/track-event'
import EnterpriseCTA from 'components/EnterpriseCTA'
import PauseVideoScreen from './PauseVideoScreen'

type ContactSalesVideoScreenProps = {
  isSample?: boolean
  onCTAClick?: () => void
}

const ContactSalesVideoScreen = ({
  isSample,
  onCTAClick,
}: ContactSalesVideoScreenProps) => {
  const { t } = useTranslation('@mc/next')
  const { skillCategory } = useStaticData<{ skillCategory: { name: string } }>()

  const captionTextKey = isSample
    ? 'course.details.sample'
    : 'course.details.trailer'

  return (
    <PauseVideoScreen
      captionText={t(captionTextKey)}
      actionText={t('skillCategoryPage.exploreSamples.pauseScreenActionText')}
      pricingText={t('skillCategoryPage.exploreSamples.pauseScreenContactText')}
      buttonGroup={
        <EnterpriseCTA
          className='mc-mt-8'
          pageSource={`MAW Skills:${skillCategory.name}`}
          location={Locations.VIDEO_PLAYER_PAUSE_SCREEN}
          onClick={onCTAClick}
          buttonText={t('skillCategoryPage.exploreSamples.pauseScreenCTA')}
          scrollToForm
          href='#contact-form'
        />
      }
    />
  )
}

export default withI18nContext(i18nInstance)(ContactSalesVideoScreen)
